
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Unter Schlafhygiene versteht man Verhaltensweisen und Massnahmen, die einen guten und gesunden Schlaf ermöglichen und fördern. Das Wichtigste ist dabei ein regelmässiger Schlaf-Wach-Rhythmus. `}<M mdxType="M">{`Darum sollte man am Morgen immer etwa um die gleiche Zeit aufstehen und nachts immer ungefähr zur selben Zeit zu Bett gehen.`}</M>{` Es wird empfohlen, auch am Wochenende grössere Zeitverschiebungen im Schlaf-Wach-Rhythmus zu verhindern. Sonst verpassen Sie sich einen unnötigen Mini-Jetlag. Kein Scherz, sondern wissenschaftliche Erkenntnis. `}</p>
    <b>Weitere Regeln und Tipps:</b><br /><br />
    <I mdxType="I">Ein ruhiges, dunkles und eher kühles Schlafzimmer fördert die Schlafqualität. Auf eine gute Matratze achten.</I>
    <I mdxType="I">Keine Arbeit, Essen oder Geräte mit ins Bett nehmen. Das Bett ist nur für Sex und zum Schlafen da.</I>
    <I mdxType="I">Entwickeln Sie ein Einschlafritual: Tee aufbrühen, ein Bad nehmen, ein Buch lesen etc.</I>
    <I mdxType="I">Wer nachts friert oder schwitzt, schläft weniger gut. Für die meisten Menschen liegt die ideale Schlaftemperatur zwischen 16 und 18°C.</I>
    <I mdxType="I">Weder mit zu vollem noch zu leerem Magen ins Bett gehen.</I>
    <I mdxType="I">Trinken Sie drei Stunden vor dem Schlafengehen keinen Alkohol und vier bis acht Stunden vor dem Schlafengehen keine koffeinhaltigen Getränke.</I>
    <I mdxType="I">Rauchen Sie nicht mehr nach 19 Uhr.</I>
    <I mdxType="I">Vermeiden Sie körperliche Überanstrengung kurz vor dem Schlafen.</I>
    <I mdxType="I">Spätestens eine Stunde vor dem Schlafengehen die elektronischen Geräte ausschalten. </I>
    <I mdxType="I">Keine emotional aufregende oder starke Konzentration erfordernde Aktivitäten unmittelbar vor der Schlafenszeit.</I>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;